import { isFeatureEnabled } from '~/app/utils/feature-flag'

/**
 * Feature flag에 따른 조건부 CSS import
 */
if (isFeatureEnabled('newCartPage')) {
  require('./reset-fix-v2.scss') // tailwind 적용
  require('./app-v2.scss') // scrollbar-width 복원
} else {
  require('./reset-fix.scss') // 기존
  require('./app.scss') // 기존
}
